import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

import {
  HEADER_HEIGHT,
  MAX_PAGE_HEIGHT,
  PAGE_CONTAINER_HEADER_HEIGHT,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  backButton: {
    marginBottom: theme.spacing(1),
    width: 'fit-content',
  },
  bugReportWrapper: {
    height: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${PAGE_CONTAINER_HEADER_HEIGHT} - 88px)`,
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${PAGE_CONTAINER_HEADER_HEIGHT} - 88px)`,

    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },

  bugReportMessagesContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  newMessageWrapper: {},
  newMessageContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),

    '& button': {
      marginBottom: theme.spacing(1),
    },
  },
  uploadedFilesWrapper: {
    display: 'flex',
    overflowY: 'auto',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  statusField: {
    width: '200px',
    marginBottom: 0,
  },
}));
